<template>
  <div class="mfa-container" style="max-width: 2000px !important">
    <h6 style="padding: 0;">{{$t('map.area')}}</h6>
    <div class="mt-3 mb-2">
      <b-button v-for="(v,k,i) in $c.MF_AREA" variant="white" size="sm" :key="i"
                :pressed="checkArea(v)" @click="toggleArea(v)">{{k}}</b-button>
    </div>
    <!-- Exculsive -->
    <div v-if="checkArea($c.MF_AREA[$t('map.all')]) || checkArea($c.MF_AREA[$t('map.exclusive_area')])">
      <h6 class="mt-5" style="padding: 0;">{{$t('map.exclusive_area')}}
        <small class="price">
          {{excls[0] + $t('room_info_popup.pyong')}} ~
          {{(excls[1] == 50) ? $t('map.unlimited') : excls[1] + $t('room_info_popup.pyong')}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="excls" :enable-cross="false" :min="0"
                  :max="50" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
    <!-- Real -->
    <div v-if="checkArea($c.MF_AREA[$t('map.all')]) || checkArea($c.MF_AREA[$t('map.real_area')])">
      <h6 class="mt-5">{{$t('map.real_area')}}
        <small class="price">
          {{reals[0] + $t('room_info_popup.pyong')}} ~
          {{(reals[1] == 50) ? $t('map.unlimited') : reals[1] + $t('room_info_popup.pyong')}}
        </small>
      </h6>
      <div class="mt-3 mb-5 mr-3 ml-3">
        <vue-slider v-model="reals" :enable-cross="false" :min="0"
                  :max="50" :tooltip="'none'" :marks="marks">
          <template v-slot:mark="{pos, label}">
            <div class="custom-mark text-center" :style="{ left: `${pos}%` }">
              |<br>{{ label }}
            </div>
          </template>
        </vue-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MFArea',
  data: function() {
    return {
      marks: {
        '0': {label: 0 + this.$t('room_info_popup.pyong')},
        '25': {label: 25 + this.$t('room_info_popup.pyong') + ' (83㎡)'},
        '50': {label: 50 + this.$t('map.py_more')},
      }
    };
  },
  computed: {
    excls: {
      get: function() {
        return [
          this.$store.getters.filter.exclusive_area_min,
          this.$store.getters.filter.exclusive_area_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          exclusive_area_min: v[0],
          exclusive_area_max: v[1],
        });
      },
    },
    reals: {
      get: function() {
        return [
          this.$store.getters.filter.real_area_min,
          this.$store.getters.filter.real_area_max,
        ];
      },
      set: function(v) {
        this.$store.commit('setFilter', {
          real_area_min: v[0],
          real_area_max: v[1],
        });
      },
    },
  },
  methods: {
    checkArea: function(val) {
      if (val == '')
        return this.$store.getters.filter.area_type == '';
      var flts = (this.$store.getters.filter.area_type == '' ? [] :
                  this.$store.getters.filter.area_type.split(','));
      return (flts.indexOf(val) != -1);
    },
    toggleArea: function(val) {
      if (val == '') {
        this.$store.commit('setFilter', {area_type: ''});
        return;
      }
      var flts = (this.$store.getters.filter.area_type == '' ? [] :
                  this.$store.getters.filter.area_type.split(','));
      var idx = flts.indexOf(val);
      if (idx != -1)
        flts.splice(idx, 1);
      else
        flts.push(val);
      this.$store.commit('setFilter', {area_type: flts.join(',')});
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_22;
    font-family: $korean_gd_17_r;
    padding-top: 20px;
  }
  div.mfa-container {
    padding: 40px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  button {
    margin-right: 8px;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 50px;
    padding: .375rem .75rem;
  }
  h6>small.price {
    color: $primary;
    float: right;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFArea.vue